export default __webpack_public_path__ + "static/media/mlacanica-2.2ad05b65.jpg";